// Writes both clipboard flavors so the target app picks what it understands:
// - text/html: the rendered DOM (tables, lists, formatting, and <img> with resolved presigned
//   URLs). Rich editors like Google Docs fetch those URLs on paste and re-host their own copy,
//   so the pasted images survive the presigned URL expiring.
// - text/plain: the raw markdown fallback for plain editors; its xqviz:// image tags are internal
//   references that don't resolve outside the app.
// Falls back to writeText when the browser lacks ClipboardItem or the rich write fails.
export const copyRichText = async (html: string, plainText: string): Promise<void> => {
  if (typeof ClipboardItem !== 'undefined' && navigator.clipboard?.write) {
    try {
      const item = new ClipboardItem({
        'text/html': new Blob([html], { type: 'text/html' }),
        'text/plain': new Blob([plainText], { type: 'text/plain' }),
      });
      await navigator.clipboard.write([item]);
      return;
    } catch {
      // Fall through to the plain-text path (e.g. Safari rejecting the async write).
    }
  }
  await navigator.clipboard.writeText(plainText);
};

export const copyPlainText = (text: string): Promise<void> => navigator.clipboard.writeText(text);
